<template>
  <header id="main-header" :class="{'page-header': true, 'page-header-collapsed': collapsed}">
    <div class="page-title-wrapper">
      <h1 class="page-title page-title-main"></h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: ['collapsed'],
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/Header/Header.vue